export function parseTextIntoParagraphs(text: string): string[] {
  const lines = text.split("\n");
  const result: string[] = [];

  for (const line of lines) {
    const trimmed = line.trim();
    if (trimmed) {
      result.push(trimmed);
    }
  }

  return result;
}
